import { getUrlParam, getValue } from '@/libs/functions/getValue'
import goTo from '@/libs/functions/goTo'
import { getStorage, setStorage } from '@/libs/functions/onStorage'
// 特殊的行方处理逻辑
const handleBankJS = () => {
  const channel = getUrlParam('channel') || getStorage('channel')
  return new Promise(async (resolve, reject) => {
    try {
      // 富滇银行
      if (
        channel === 'fudian' ||
        window.location.href.includes('/special/auth/fudian')
      ) {
        setStorage('channel', 'fudian')
        await require('./fudian/Fw.js')
        const Fw = (window as any).Fw
        if (!Fw) {
          console.log('加载富滇Fw.js报错')
          return
        }
        Fw.setPageTitle({
          title: '富瑞悦享',
        })
        Fw.goH5Return()
        document.addEventListener(
          '_onNavigateBack',
          async function (e) {
            const href = window.location.href
            if (
              href.includes('/special/auth/fudian') ||
              href.includes('/promo/template')
            ) {
              Fw.navigateBack()
            } else {
              goTo(-1)
            }
          },
          false,
        )
      }
      // 民生出游银行
      else if (channel === 'msbank') {
        const Fw = (window as any).Fw
        if (!Fw) {
          console.log('加载民生出游银行js报错')
          return
        }
        Fw?.hideWaitPanel()
        console.log('民生出游银行js加载成功 Fw?.hideWaitPanel()')
      }
    } catch (error) {
      console.log('引入特殊js报错：', channel, error)
    }
  })
}

export const routeChangeHook = () => {
  const channel = getUrlParam('channel') || getStorage('channel') || ''
  try {
    if (channel === 'msbank') {
      const Fw = (window as any).Fw
      if (!Fw) {
        console.log('加载民生出游银行js报错')
        return
      }
      Fw?.hideWaitPanel()
      console.log('民生出游银行js加载成功 Fw?.hideWaitPanel()')
    }
  } catch (error) {
    console.log('路由切换时隐藏民生出游银行js报错：', error)
  }
}

export default handleBankJS
